import { Client, GraphError, LargeFileUploadTask } from '@microsoft/microsoft-graph-client';
import { Keys, messages } from '../../settings';
import Constants from '../../settings';
import compress, { decompress } from '../../utilities/flateCompressDecompress';
import { Flate } from '../_globalContext/context';
import { ErrorHandler, msgraphGet } from './oneDriveApi';

export const prepareAppData = (function () {
  let currentInit: Promise<void>;

  return async function (graphClient: Client) {
    if (currentInit === undefined) {
      currentInit = graphClient.api('/me/drive/special/approot/children').post({
        name: 'AppDataInit',
        folder: {},

        ['@microsoft.graph.conflictBehavior']: 'replace',
      });
    }

    await currentInit;
  };
})();

/**
 * Saves/replaces a Fadila data file to users drive
 */
export const putFile = (graphClient: Client, errorHandler: ErrorHandler, flate: Flate) =>
  async function doPutFile<T>(fileName: string, fileData: T) {
    try {
      const requestUrl = `/me/drive/special/approot:/${fileName}:/createUploadSession`;
      const payload = {
        item: {
          '@microsoft.graph.conflictBehavior': 'replace',
          name: fileName,
        },
      };

      const body = compress(fileData, flate);

      const uploadSession = await LargeFileUploadTask.createUploadSession(
        graphClient,
        requestUrl,
        payload,
      );

      return await fetch(uploadSession.url, {
        method: 'PUT',
        body,
        headers: new Headers({
          'Content-Length': `${body.byteLength}`,
          'Content-Range': `bytes ${0}-${body.byteLength - 1}/${body.byteLength}`,
        }),
      });
    } catch (err) {
      if (errorHandler) {
        errorHandler(err);
      } else {
        throw err;
      }
    }
  };

export const getDataFile = (graphClient: Client, errorHandler: ErrorHandler, flate: Flate) =>
  async function (fileName: string) {
    const driveItem = await msgraphGet(
      graphClient,
      errorHandler,
    )(`/me/drive/special/approot:/${fileName}`);
    const res = await fetch(driveItem[Constants.MsGraphDlUrlProp]);

    if (res.ok) {
      const bytes = await res.arrayBuffer();

      return decompress(bytes, flate);
    } else {
      throw res;
    }
  };

export const getOrCreateDataFile = (
  graphClient: Client,
  errorHandler: ErrorHandler,
  flate: Flate,
) =>
  async function <T>(fileName: string, defaultData: T) {
    try {
      return (await getDataFile(graphClient, errorHandler, flate)(fileName)) as T;
    } catch (err) {
      try {
        if (err instanceof GraphError && err.statusCode === 404) {
          // Assume first launch, init approot folder
          await prepareAppData(graphClient);

          return putFile(
            graphClient,
            errorHandler,
            flate,
          )(fileName, defaultData).then(() => defaultData, errorHandler);
        } else {
          if (errorHandler) {
            errorHandler(err);
            return Promise.reject();
          } else {
            return Promise.reject(messages(Keys.libraryLoadError));
          }
        }
      } catch (err) {
        if (errorHandler) {
          errorHandler(err);
        }

        return Promise.reject();
      }
    }
  };
